export default async function a1Connect({ next, router }) {
  const a1ConnectIsEnabled = window.Laravel.a1ConnectEnabled;

  if (a1ConnectIsEnabled) {
    return router.push({ name: 'a1-connect' });
  }

  return next();
}
